import { passThroughAxios } from './passThrough.axios'

export default {
  async getActiveWarningBanners() {
    try {
      const response = await passThroughAxios.get('warning-banner')

      return response.data
    } catch (e) {
      if (e.response.status === 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
  getAllWarningBanners() {
    return passThroughAxios.get('warning-banner/all')
  },
  createNewWarningBanner(payload) {
    return passThroughAxios.post('warning-banner', payload)
  },
  updateWarningBanner(id, payload) {
    return passThroughAxios.put(`warning-banner/${id}`, payload)
  },
  deleteWarningBanner(id) {
    return passThroughAxios.delete(`warning-banner/${id}`)
  },
}
